import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import Header from './components/layout/Header'
import Footer from './components/layout/Footer'
import Preloader from './components/layout/Preloader'
import Home from './pages/Home'
import About from './pages/About'
import Music from './pages/Music'
import Books from './pages/Books'
import Worship from './pages/Worship'
import EAJ from './pages/EAJ'
import Support from './pages/Support'
import Contact from './pages/Contact'

function App() {
  const [loading, setLoading] = useState(true)
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('esaieTheme')
    return saved ? JSON.parse(saved) : false
  })

  useEffect(() => {
    localStorage.setItem('esaieTheme', JSON.stringify(darkMode))
    
    if (darkMode) {
      document.documentElement.classList.add('dark')
      document.documentElement.style.backgroundColor = '#000000'
      document.body.style.backgroundColor = '#000000'
    } else {
      document.documentElement.classList.remove('dark')
      document.documentElement.style.backgroundColor = ''
      document.body.style.backgroundColor = ''
    }
  }, [darkMode])

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false)
    }, 3000)
    return () => clearTimeout(timer)
  }, [])

  if (loading) {
    return <Preloader />
  }

  return (
    <I18nextProvider i18n={i18n}>
      <div className={darkMode ? 'dark' : ''}>
        <div className={`min-h-screen transition-colors duration-500 ${darkMode ? 'bg-primary-black' : 'bg-white'}`}>
          <Router>
            <Header darkMode={darkMode} setDarkMode={setDarkMode} />
            <AnimatePresence mode="wait">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/music" element={<Music />} />
                <Route path="/books" element={<Books />} />
                <Route path="/worship" element={<Worship />} />
                <Route path="/eaj" element={<EAJ />} />
                <Route path="/support" element={<Support />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </AnimatePresence>
            <Footer />
          </Router>
        </div>
      </div>
    </I18nextProvider>
  )
}

export default App